import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import "./../Assets/css/utility.css";
import { getMenus, room_checkout_detail } from "../Pages/apis";
import { NewOrder } from "../Components/ViewModals/NewOrder";
import { Modal } from "react-bootstrap";
import DeliveredOrder from "../Components/ViewModals/DeliveredOrder";
import axios from "axios";
// import RoundedImg from "./../Assets/images/Rounded1.png";
// import { ReactComponent as Rounded } from "./../Assets/images/svg/Rounded.svg";
import { data } from "../variables/variables";

let dep_id = "";

function Floor({
  floor_rooms,
  floorName,
  setShowRightSide,
  showRightSide,
  setRoomObj,
  roomColor,
  roomObj,
  setCheckOrder,
}) {
  const [orderModal, setOrderModal] = useState(false);
  const [delivered_order, setDelivered_Order] = useState(false);
  const [check_delivere_detail, setCheck_delivere_detail] = useState([]);
  const [room_name, setRoom_name] = useState("");
  const [session, setSession] = useState({});
  const [check_deliver_Modal, setcheck_deliver_Modal] = useState(false);
  const [room_id, setRoom_id] = useState("");
  const [check_Out_Modal, setcheck_Out_Modal] = useState(false);
  const [check_out_detail, setCheck_out_detail] = useState([]);
  const [ObjRoom, setObjRoom] = useState({});

  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: "Bearer " + user?.token,
  };
  if (user?.name === "kitchen") {
    dep_id = 3;
  } else {
    dep_id = 2;
  }

  const handleRoomCode = (room) => {
    setShowRightSide(true);
    setRoomObj(room);
    //console.log(room);
  };
  const bgColor = (room) => {
    let bg;
    if (room?.room_status_id === 1) {
      if (room?.ord_status === 1) {
        bg = "red";
      } else if (room?.ord_status === 2) {
        bg = "#90EE90";
      } else if (room?.ord_status === 3) {
        bg = "#00FF00";
      } else {
        bg = "lightblue";
      }
    } else {
      bg = "lightgray";
    }

    return bg;
  };

  const handleModal = () => {
    setOrderModal(false);
  };

  const CancelDeliverdModal = () => {
    setDelivered_Order(false);
  };

  const deliveredModal = (room) => {
    setDelivered_Order(true);
    handleDeliverseDetail(room.id);
  };

  const AddOrder = (room) => {
    // console.log(room, "room");
    setOrderModal(true);
    setObjRoom(room);
  };

  const CancelSidebarModel = () => {
    setShowRightSide(false);
  };

  const handleDeliverseDetail = (id) => {
    setcheck_deliver_Modal(true);
    axios.get(room_checkout_detail + "/" + id, { headers }).then((res) => {
      if (res.data.status === 200) {
        setCheck_delivere_detail(res.data.orders);
        setSession(res.data.session);
        setRoom_id(id);
      }
    });
  };

  const handleDelivereDetail = (id) => {
    setcheck_Out_Modal(true);
    axios.get(room_checkout_detail + "/" + id, { headers }).then((res) => {
      if (res.data.status === 200) {
        setCheck_out_detail(res.data.orders);
        setSession(res.data.session);
        // setRoom_id(id);
        // let update_rooms = allRooms.map((item) => {
        //   if (id == item?.id) {
        //     item = { ...item, room_status_id: 2 };
        //   }
        //   return item;
        // });
        // setAllRooms(update_rooms);
      }

      // setCheckout_Model(false);
    });
  };

  return (
    <div className="d-flex flex-column">
      <h5 className="heading_Set">{floorName}</h5>
      <div className="d-flex text-wrap ">
        {floor_rooms.map((room) => (
          <div
            className={`${showRightSide ? "room_design" : "room_design1"} ${
              room?.blink ? "blink" : ""
            }`}
            style={{
              backgroundColor: `${bgColor(room)}`,
              visibility: `${
                room?.id === 24 || room?.id === 26 || room?.id === 28
                  ? "hidden"
                  : ""
              }`,
            }}
            key={room?.id}
            onClick={() => handleRoomCode(room)}
          >
            {user?.name === "kitchen" && room?.room_status_id === 1 ? (
              <div className="d-flex justify-content-between">
                <p
                  onClick={() => deliveredModal(room)}
                  style={{ color: "blue", fontSize: "15px", marginLeft: "3px" }}
                >
                  Deliver
                </p>{" "}
                <p
                  onClick={() => AddOrder(room)}
                  style={{
                    color: "blue",
                    fontSize: "15px",
                    marginRight: "3px",
                  }}
                >
                  Add
                </p>
              </div>
            ) : (
              ""
            )}
            {room?.name}
          </div>
        ))}

        <Modal show={orderModal} onHide={handleModal}>
          <Modal.Header>
            <p className="text-bold">New Order </p>
            <p className="text-bold cursor-pointer" onClick={handleModal}>
              x
            </p>
          </Modal.Header>
          <Modal.Body>
            <NewOrder
              roomObj={ObjRoom}
              setOrderModal={setOrderModal}
              setCheckOrder={setCheckOrder}
              // getOrders={getOrders}
            />
          </Modal.Body>
        </Modal>

        <Modal show={delivered_order} onHide={CancelDeliverdModal}>
          <Modal.Header>
            <Modal.Title>Delivered Orders </Modal.Title>
            <p
              className="text-bold cursor-pointer"
              onClick={CancelDeliverdModal}
            >
              x
            </p>
          </Modal.Header>
          <Modal.Body>
            <DeliveredOrder
              room={room_name}
              roomObj={roomObj}
              check_delivere_detail={check_delivere_detail}
              session={session}
            />
          </Modal.Body>
          <Modal.Footer>
            <div className="custom_flex justify-content-end">
              <button
                onClick={CancelDeliverdModal}
                className="btn btn-secondary btn-sm active"
                role="button"
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default Floor;
